<ng-container *transloco="let t">
  <h2 style="margin-block-start: 0 !important; margin-block-end: 0 !important;" mat-dialog-title>{{ t('DANCE_MANAGER_EVENT.CONTACT_PARTICIPANTS.TITLE') }}</h2>
  
  <mat-dialog-content class="mat-typography">
    <p>{{ t('DANCE_MANAGER_EVENT.CONTACT_PARTICIPANTS.TEXT') }}<br/></p>
    
    <form [formGroup]="messageForm">
        <df-shared-lib-quill-editor
          [hasError]="
            messageForm.controls.message.hasError('characterCountExceeded') ||
            (messageForm.controls.message.hasError('required') &&
              messageForm.controls.message.touched)"
          [enableMentions]="true"
          [enableCounter]="true"
          [isRequired]="true"
          [maxLength]="2000"
          [id]="'message'"
          [placeholder]="'DANCE_MANAGER_EVENT.CONTACT_PARTICIPANTS.PLACE_HOLDER'"
          customFormControlName="message"
          class="pad-matformfield-description"
        ></df-shared-lib-quill-editor>
        <mat-hint align="end">{{messageForm.get('message')?.value?.length || 0}}/{{maxLength}}</mat-hint>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <div class="invite-button-container align-end">
      <df-shared-lib-button
        [buttonLabel]= "t('GENERIC_WRAPPER.CANCEL')"
        [materialButtonStyleType]="'outlined'"
        [minWidth]="'100%'"
        mat-dialog-close>
      </df-shared-lib-button>
      <df-shared-lib-button
        [buttonLabel]= "t('DANCE_MANAGER_EVENT.CONTACT_PARTICIPANTS.SENT') | titlecase"
        [materialButtonStyleType]="'flat'"
        [minWidth]="'100%'"
        cdkFocusInitial
        [isDisabled]="!messageForm.valid"
        (click)="send()">
      </df-shared-lib-button>
    </div>
  </mat-dialog-actions>
</ng-container>
